type BrandColors = {
  light: string
  dark: string
}

export function handleBrandColors({ light, dark }: BrandColors) {
  const stylesheet = new CSSStyleSheet()
  document.adoptedStyleSheets = [...document.adoptedStyleSheets, stylesheet]

  stylesheet.replaceSync(`
    html[data-theme='light'] {
      --accent-brand-default: ${light};
      --accent-brand-light: color-mix(in srgb, ${light}, #fff 80%);
      --accent-brand-medium: color-mix(in srgb, ${light}, #fff 20%);
      --accent-brand-bold: color-mix(in srgb, ${light}, #000 40%);
    }

    html[data-theme='dark'] {
      --accent-brand-default: color-mix(in srgb, ${dark}, #fff 20%);
      --accent-brand-light: color-mix(in srgb, ${dark}, #000 60%);
      --accent-brand-medium: color-mix(in srgb, ${dark}, #fff 40%);
      --accent-brand-bold: color-mix(in srgb, ${dark}, #fff 80%);
    }
  `)
}

export function handleFavicon(href: string) {
  const links = document.querySelectorAll(
    "link[rel='icon'], link[rel='shortcut icon']",
  )
  links.forEach((link) => link.remove())

  const link = document.createElement('link')
  link.rel = 'icon'
  link.type = 'image/svg+xml'

  link.href = `${href}${href.includes('?') ? '&' : '?'}v=${Date.now()}`

  document.head.appendChild(link)
}
